import { FC, useState } from "react";
import { MobileModal } from "@/components/Modal";
import { MobilePaperTitle } from "@/components/PageTitle";
import { SearchTextField } from "@/components/TextField";
import Button from "@/components/Button";
import styles from "./MobileSearchFilter.module.scss";

type Props = {
  onClose: () => void;
  onSearch: (searchKey: string) => void;
  inputSearchKey: string;
};

const MobileSearchFilter: FC<Props> = ({
  onClose,
  onSearch,
  inputSearchKey,
}) => {
  const [searchKey, setSearchKey] = useState<string>(inputSearchKey);
  return (
    <MobileModal>
      <MobilePaperTitle title="Search" onGoBack={onClose} />
      <div className={styles.root}>
        <SearchTextField
          value={searchKey}
          onChange={(e) => setSearchKey(e.currentTarget.value)}
          className={styles.searchField}
          placeholder="Search by keyword ..."
          iconPlacement="start"
        />
        {/* add suggested or recent search */}
        <Button
          //   disabled={!searchKey}
          onClick={() => onSearch(searchKey)}
          className={styles.submitButton}
        >
          Show Results
        </Button>
      </div>
    </MobileModal>
  );
};

export default MobileSearchFilter;
